import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { UiKitToastApiContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
const UiKitToastsInternalContextProviderComponent = props => {
  const [apiByPlacement, setApi] = React.useState({
    'bottom-center': null,
    'bottom-right': null,
    'top-center': null,
    'top-right': null
  });
  const [indentByPlacement, setIndent] = React.useState({
    'bottom-center': '',
    'bottom-right': '',
    'top-center': '',
    'top-right': ''
  });
  const setToastApiByPlacement = React.useCallback((api, placement) => {
    setApi(currentApis => _objectSpread(_objectSpread({}, currentApis), {}, {
      [placement]: api
    }));
  }, []);
  const setIndentByPlacement = React.useCallback((placement, indent) => {
    setIndent(currentIndents => _objectSpread(_objectSpread({}, currentIndents), {}, {
      [placement]: indent
    }));
  }, []);
  const contextValue = React.useMemo(() => ({
    apiByPlacement,
    setToastApiByPlacement,
    indentByPlacement,
    setIndentByPlacement
  }), [apiByPlacement, setToastApiByPlacement, indentByPlacement, setIndentByPlacement]);
  return /*#__PURE__*/_jsx(UiKitToastApiContext.Provider, {
    value: contextValue,
    children: props.children
  });
};
export const UiKitToastsInternalContextProvider = /*#__PURE__*/React.memo(UiKitToastsInternalContextProviderComponent);